import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tablePagination: {
    padding: '10px 0 !important',
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
  },
  filtersContainer: {
    display: 'flex',
    justifyItems: 'center',
    marginBottom: '20px',
    marginTop: '20px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  searchBarContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  searchBar: {
    background: '#f2f2f2',
    maxWidth: '500px',
  },
  createTrainingWrapper: {
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      color: theme.palette.text.secondary,
    },
  },
  textarea: {
    '& .MuiInputBase-root': {
      height: 'unset',
      paddingTop: 'unset',
      paddingBottom: 'unset',
    },
  },
  drillIcon: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.text.secondary,
    },
  },
  lockBadgeOnIconButton: {
    '& .MuiBadge-badge': {
      width: 12,
      height: 12,
      minWidth: 12,
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiBadge-anchorOriginTopRightCircular .MuiSvgIcon-root': {
      fontSize: 10,
    },
  },
  paper: {
    margin: 'auto',
    maxWidth: 900,
    padding: theme.spacing(2, 0),
  },
  timingBox: {
    marginLeft: 'auto',
  },
  styledImage: {
    objectFit: 'contain',
    width: '100%',
    height: '40vh',
    borderRadius: '12px',
  },
  categoriesButton: {
    marginRight: theme.spacing(1),
  },
  dialogContainer: {
    padding: '12px 24px',
  },
  dialogContent: {
    display: 'flex',
    height: '80vh',
    padding: 0,
  },
  gridContainer: {
    height: '100%',
    margin: 0,
  },
  mediaSection: {
    height: '100%',
    padding: theme.spacing(2.5),
  },
  detailsSection: {
    height: '100%',
    overflowY: 'auto',
    padding: theme.spacing(5),
  },
  contentContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #e8e8e8',
    borderRadius: '5px',
    padding: '20px',
  },
  videoContainer: {
    width: '100%',
    paddingTop: '56.25%',
    position: 'relative',
    overflow: 'hidden',
  },
  imageContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  image: {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
}))

export default useStyles
